import React, { Component } from 'react';

class QuoteText extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      (this.props.selectedChoices) ?
          (
            <span>{ (this.props.numberOfChoices > 1 && this.props.index > 1 && this.props.selectedChoices) ? this.props.seperator : ' ' }{this.props.prefix}{ ' ' }
            {
              Object
                .keys(this.props.selectedChoices)
                .map( (key, index) => {
                  return (
                    <span key={key} className="colour--yellow">

                    <span class="text--underline">{(this.props.valuesLabel) ? this.props.valuesLabel : ''}{this.props.selectedChoices[key]}</span>
                    {
                      (this.props.selectedChoices.length-1 > index) ?
                        (this.props.type == "Range") ?
                        ' & '
                        : ', '
                      :
                      (this.props.postfix) ? ' ' : ''
                    }
                    </span>
                  )
              })
            }
            {this.props.postfix}

            </span>

          )

      : ''
    )
  }
}

export default QuoteText
